import styled from "@emotion/styled";
import { Badge, BadgeProps } from "../../../shared/Badge";
import { ButtonSizes } from "../types";

const getBadgeMinWidth = (buttonSize: ButtonSizes) => {
    switch (buttonSize) {
        case "large":
        case "medium":
            return 9;
        case "small":
        case "xsmall":
            return 1;
    }
};

export const getBadgeSize = (buttonSize: ButtonSizes) => {
    switch (buttonSize) {
        case "large":
        case "medium":
            return 16;
        case "small":
        case "xsmall":
            return 8;
    }
};

const ButtonSizeToOffset: Record<ButtonSizes, number> = {
    large: -7,
    medium: -7,
    small: -3.5,
    xsmall: -4,
};

type GetBadgeOffestOptions = {
    readonly buttonSize: ButtonSizes;
    readonly offset?: number;
};

const getBadgeOffset = ({ buttonSize, offset = 0 }: GetBadgeOffestOptions) => {
    return ButtonSizeToOffset[buttonSize] - offset;
};

interface ButtonBadgeProps extends BadgeProps {
    buttonSize: ButtonSizes;
}

export const ButtonBadge = styled(Badge)<ButtonBadgeProps>`
    top: ${({ buttonSize, offset }) => getBadgeOffset({ buttonSize, offset: offset?.y ?? 0 })}px;
    right: ${({ buttonSize, offset }) => getBadgeOffset({ buttonSize, offset: offset?.x ?? 0 })}px;
    // these next two numbers differ from figma because of the .5px padding figma gives to text
    border-radius: 16px;
    padding: 0px 3.5px;
    min-width: ${({ buttonSize }) => getBadgeMinWidth(buttonSize)}px;
`;
